export default class PatRezept {
    public patrezept_id: number | null = null;
    public bezeichnung: string | null = null;
    public verabreichung: string | null = null;

    constructor(rezept?: Partial<PatRezept | null>) {
        Object.assign(this, rezept);
    }
}
